<div class="container" [ngClass]="{ mobile: (isMobile$ | async) }">
  <h2 class="mat-headline-3 align-center">{{ 'WM_TECH.PRIVACY.TITLE' | translate }}</h2>

  <ng-container *ngIf="privacyPolicy; else loading">
    <div class="wrapper" *ngIf="privacyPolicy" [innerHtml]="tr.currentLang === 'en' ? privacyPolicy.privacy_policy_content_en : privacyPolicy.privacy_policy_content_ru"></div>
  </ng-container>

  <ng-template #loading>
    <div class="wm-loading" style="width: 100%; height: 100%"></div>
  </ng-template>
</div>
